//import { useEasyServicePostApiEasyAskForQuotationEmail } from "../../../../openapi/queries";
import { showErrorToast } from "../../../configurator/renderer/tools/helper";
import { ApiErrorResponse } from "../../../configurator/renderer/tools/types";
import { useUiTranslator } from "../../../hooks/useUiTranslator";
import { emailRegex } from "../../../tools/regex";
import { BaseModal } from "../BaseModal/BaseModal";
import { LabeledInput } from "../LabeledInput/LabeledInput";
import { ModalDialogConfirm } from "../ModalDialogConfirm/ModalDialogConfirm";

import { JSX } from "react";
import { useCallback, useEffect, useState } from "react";

import { useLanguage } from "@4pace-cpq/core";
import { useGoogleReCaptcha } from "@google-recaptcha/react";
import MailIcon from "@mui/icons-material/Mail";
import RefreshIcon from "@mui/icons-material/Refresh";
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  IconButton,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid";

//import { useNavigate } from "@tanstack/react-router";

import { usePostApiAskForQuotationAskForQuotationEmail } from "./../../../openapi/backendApi";
import { QuoteFormSelect } from "./QuoteFormSelect";

interface IFormLocationItem {
  value: string;
  label: string;
}

interface ICountry {
  isocode: string;
}
interface IRegion {
  isocode: string;
}
interface IAddress {
  country: ICountry;
  email: string;
  defaultAddress: boolean;
  id: string;
  line1: string;
  phone: string;
  postalCode?: string;
  region?: IRegion;
}

interface IGeoPoint {
  latitude: number;
  longitude: number;
}
interface IPointOfService {
  label?: string;
  address: IAddress;
  displayName: string;
  geoPoint: IGeoPoint;
  name: string;
}

export const BtnAskForQuote = ({
  disabled,
}: {
  disabled?: boolean;
}): JSX.Element => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState<boolean>(false);
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState<boolean>(false);
  const [sendingHasError, setSendingHasError] = useState<boolean>(false);
  const t = useUiTranslator();
  const { selectedLanguage } = useLanguage();
  const [formUserName, setFormUserName] = useState<string>("");
  const [formUserSurname, setFormUserSurname] = useState<string>("");
  const [formCompanyName, setFormCompanyName] = useState<string>("");
  const [formUserStreet, setFormUserStreet] = useState<string>("");
  const [formUserStreetNr, setFormUserStreetNr] = useState<string>("");
  const [formUserZipCode, setFormUserZipCode] = useState<string>("");
  const [formUserCity, setFormUserCity] = useState<string>("");
  const [formUserEmail, setFormUserEmail] = useState<string>("");
  const [formUserPhoneNr, setFormUserPhoneNr] = useState<string>("");
  const [formUserComment, setFormUserComment] = useState<string>("");
  const [formCountries, setFormCountries] = useState<IFormLocationItem[]>([]);
  const [formRegions, setFormRegions] = useState<IFormLocationItem[]>([]);
  const [formCities, setFormCities] = useState<IFormLocationItem[]>([]);
  const [formDistricts, setFormDistricts] = useState<IFormLocationItem[]>([]);
  const [currentFormCountryId, setCurrentFormCountryId] = useState<string>("");
  const [currentFormRegionId, setCurrentFormRegionId] = useState<string>("");
  const [currentFormCityId, setCurrentFormCityId] = useState<string>("");
  const [currentFormDistrictId, setCurrentFormDistrictId] =
    useState<string>("");
  const [pointsOfService, setPointsOfService] = useState<IPointOfService[]>([]);
  const [currentPointsOfService, setCurrentPointsOfService] = useState<
    string[]
  >([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [errorFetchCountries, setErrorFetchCountries] =
    useState<boolean>(false);
  const [errorFetchRegions, setErrorFetchRegions] = useState<boolean>(false);
  const [errorFetchCities, setErrorFetchCities] = useState<boolean>(false);
  const [errorFetchDistricts, setErrorFetchDistricts] =
    useState<boolean>(false);
  const [errorFetchPointsOfService, setErrorFetchPointsOfService] =
    useState<boolean>(false);

  const [errorMessage, setErrorMessage] = useState<string>("");
  const googleReCaptcha = useGoogleReCaptcha();

  //const navigate = useNavigate();

  const shortenedLanguage =
    selectedLanguage?.languageCode?.split("-")[0] ?? "en";

  const handleOpenModal = (): void => {
    setIsModalOpen(true);
  };
  const handleCloseModal = (): void => {
    setIsModalOpen(false);
  };

  const handleOpenConfirmModal = (): void => {
    setIsConfirmModalOpen(true);
  };

  const handleCloseConfirmModal = (): void => {
    setIsConfirmModalOpen(false);
    setSendingHasError(false);
  };

  const handleOpenSuccessModal = (): void => {
    setIsModalOpen(false);
    setIsConfirmModalOpen(false);
    setIsSuccessModalOpen(true);
  };

  const handleCloseSuccessModal = async (): Promise<void> => {
    setIsSuccessModalOpen(false);
    setIsModalOpen(false);
    /*    await navigate({
      to: "/",
    }); */
    window.location.reload();
  };

  const { mutate: askForQuotationEmail } =
    usePostApiAskForQuotationAskForQuotationEmail();

  /*  const { mutate: sendQuotationEmail } =
    usePostApiAskForQuotationSendAskForQuotationEmailWithJson(); */

  const fetchCountries = useCallback(async () => {
    setIsLoading(true);
    setErrorFetchCountries(false);
    setFormRegions([]);
    setCurrentFormRegionId("");
    setFormCities([]);
    setCurrentFormCityId("");
    setFormDistricts([]);
    setCurrentFormDistrictId("");
    setPointsOfService([]);
    setCurrentPointsOfService([]);
    askForQuotationEmail(
      {
        data: { language: shortenedLanguage },
      },
      {
        onSuccess: ({ data }) => {
          if (data && data.countries) {
            setFormCountries(
              data.countries
                .filter((country) => typeof country.value === "string")
                .map((country) => ({
                  value: country.value as string,
                  label: country.label ?? "",
                })),
            );
          }
        },
        onError: (error) => {
          console.warn(error);
          const errorBody = error.info as ApiErrorResponse | undefined;
          setErrorFetchCountries(true);
          showErrorToast(
            t(
              errorBody?.key
                ? `CustomApp:${errorBody.key}`
                : "CustomApp:toast.error.generic",
              "An error occurred while processing your request.",
              { params: errorBody?.params },
            ),
          );
        },
      },
    );
    setIsLoading(false);
  }, [askForQuotationEmail, shortenedLanguage, t]);

  const fetchRegions = useCallback(async () => {
    if (currentFormCountryId === "BR") {
      setIsLoading(true);
      setErrorFetchRegions(false);
      setFormRegions([]);
      setCurrentFormRegionId("");
      setFormCities([]);
      setCurrentFormCityId("");
      setFormDistricts([]);
      setCurrentFormDistrictId("");
      setPointsOfService([]);
      setCurrentPointsOfService([]);
      askForQuotationEmail(
        {
          data: {
            language: shortenedLanguage,
            country: currentFormCountryId,
          },
        },
        {
          onSuccess: ({ data }) => {
            if (data && data.regions) {
              setFormRegions(
                data.regions
                  .filter((region) => typeof region.value === "string")
                  .map((region) => ({
                    value: region.value as string,
                    label: region.label + " (" + region.value + ")",
                  })),
              );
            }
          },
          onError: (error) => {
            console.warn(error);
            const errorBody = error.info as ApiErrorResponse | undefined;
            setErrorFetchRegions(true);
            showErrorToast(
              t(
                errorBody?.key
                  ? `CustomApp:${errorBody.key}`
                  : "CustomApp:toast.error.generic",
                "An error occurred while processing your request.",
                { params: errorBody?.params },
              ),
            );
          },
        },
      );
      setIsLoading(false);
    }
  }, [askForQuotationEmail, shortenedLanguage, currentFormCountryId, t]);

  const fetchCities = useCallback(async () => {
    if (currentFormCountryId === "BR") {
      setIsLoading(true);
      setErrorFetchCities(false);
      setFormCities([]);
      setCurrentFormCityId("");
      setFormDistricts([]);
      setCurrentFormDistrictId("");
      setPointsOfService([]);
      setCurrentPointsOfService([]);
      askForQuotationEmail(
        {
          data: {
            language: shortenedLanguage,
            country: currentFormCountryId,
            region: currentFormRegionId,
          },
        },
        {
          onSuccess: ({ data }) => {
            if (data && data.towns) {
              setFormCities(
                data.towns
                  .filter((towns) => typeof towns.value === "string")
                  .map((towns) => ({
                    value: towns.value as string,
                    label: towns.label ?? "",
                  })),
              );
            }
          },
          onError: (error) => {
            console.warn(error);
            const errorBody = error.info as ApiErrorResponse | undefined;
            setErrorFetchCities(true);
            showErrorToast(
              t(
                errorBody?.key
                  ? `CustomApp:${errorBody.key}`
                  : "CustomApp:toast.error.generic",
                "An error occurred while processing your request.",
                { params: errorBody?.params },
              ),
            );
          },
        },
      );
      setIsLoading(false);
    }
  }, [
    askForQuotationEmail,
    shortenedLanguage,
    currentFormCountryId,
    currentFormRegionId,
    t,
  ]);

  const fetchDistricts = useCallback(async () => {
    if (currentFormCountryId === "BR") {
      setIsLoading(true);
      setErrorFetchDistricts(false);
      setFormDistricts([]);
      setCurrentFormDistrictId("");
      setPointsOfService([]);
      setCurrentPointsOfService([]);
      askForQuotationEmail(
        {
          data: {
            language: shortenedLanguage,
            country: currentFormCountryId,
            region: currentFormRegionId,
            town: currentFormCityId,
          },
        },
        {
          onSuccess: ({ data }) => {
            if (data && data.districts) {
              setFormDistricts(
                data.districts
                  .filter((districts) => typeof districts.value === "string")
                  .map((districts) => ({
                    value: districts.value as string,
                    label: districts.label ?? "",
                  })),
              );
            } else {
              setPointsOfService(
                (data?.pointsOfService ?? [])
                  .filter(
                    (pos): pos is IPointOfService => pos.address !== undefined,
                  )
                  .map((pos) => ({ ...pos, label: pos.label || "" })),
              );
              setCurrentPointsOfService(
                [data?.pointsOfService?.[0]?.address?.id].filter(
                  (id): id is string => typeof id === "string",
                ),
              );
            }
          },
          onError: (error) => {
            console.warn(error);
            const errorBody = error.info as ApiErrorResponse | undefined;
            setErrorFetchDistricts(true);
            showErrorToast(
              t(
                errorBody?.key
                  ? `CustomApp:${errorBody.key}`
                  : "CustomApp:toast.error.generic",
                "An error occurred while processing your request.",
                { params: errorBody?.params },
              ),
            );
          },
        },
      );
      setIsLoading(false);
    }
  }, [
    askForQuotationEmail,
    shortenedLanguage,
    currentFormCountryId,
    currentFormRegionId,
    currentFormCityId,
    t,
  ]);

  const fetchPointsOfService = useCallback(async () => {
    setIsLoading(true);
    setErrorFetchPointsOfService(false);
    setPointsOfService([]);
    setCurrentPointsOfService([]);
    const isBrazil = currentFormCountryId === "BR";

    const requestBody = {
      language: shortenedLanguage,
      country: currentFormCountryId,
      region: isBrazil ? currentFormRegionId : undefined,
      town: isBrazil ? currentFormCityId : undefined,
      district: isBrazil ? currentFormDistrictId : undefined,
    };

    let response;
    try {
      response = await fetch("/api/AskForQuotation/AskForQuotationEmail", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });
      if (response.status === 504) {
        showErrorToast(
          t(
            "CustomApp:toast.JmpToEasy.timeout",
            "Easy Endpoint time-out. Please try again",
          ),
        );
      }
      const data = await response.json();
      if (data.pointsOfService && data.pointsOfService.length > 0) {
        setPointsOfService(data.pointsOfService);
        setCurrentPointsOfService([data.pointsOfService[0].address.id]);
      }
    } catch (error) {
      setErrorFetchPointsOfService(true);
      console.warn(error);
    }
    setIsLoading(false);
  }, [
    shortenedLanguage,
    currentFormCountryId,
    currentFormRegionId,
    currentFormCityId,
    currentFormDistrictId,
    t,
  ]);

  const handleChangeCurrentPOS = (id: string): void => {
    let newPOSArr = [...currentPointsOfService];
    if (newPOSArr.includes(id)) {
      newPOSArr = currentPointsOfService.filter((v) => v !== id);
    } else {
      newPOSArr.push(id);
    }
    setCurrentPointsOfService(newPOSArr);
  };

  const handleSend = async (): Promise<void> => {
    setIsLoading(true);
    if (googleReCaptcha && typeof googleReCaptcha.executeV3 === "function") {
      let recaptchaToken: string;
      try {
        recaptchaToken = await googleReCaptcha.executeV3("action");
      } catch (error) {
        console.warn("Recaptcha execution failed", error);
        setSendingHasError(true);
        setErrorMessage(
          t(
            "CustomApp:toast.error.generic",
            "An error occurred while processing your request.",
          ),
        );
        setIsLoading(false);
        return;
      }
      const requestBody = {
        recaptchaToken: recaptchaToken,
        eMail: formUserEmail,
        language: selectedLanguage?.languageCode ?? "en-US",
        userName: formUserName + " " + formUserSurname,
        companyName: formCompanyName,
        address: {
          street: formUserStreet,
          streetNr: formUserStreetNr,
          zipCode: formUserZipCode,
          city: formUserCity,
        },
        phoneNumber: formUserPhoneNr || null,
        comment: formUserComment,
        emails: currentPointsOfService,
        model: {
          language: shortenedLanguage,
          country: currentFormCountryId,
          region: currentFormRegionId,
          town: currentFormCityId,
          district: currentFormDistrictId,
        },
      };

      let response;
      setSendingHasError(false);
      try {
        //sendQuotationEmail({data:requestBody}) //ToDo
        response = await fetch(
          "/api/AskForQuotation/SendAskForQuotationEmail",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(requestBody),
          },
        );

        if (response.status === 200) {
          handleOpenSuccessModal();
        } else setSendingHasError(true);
        if (!response.ok) {
          const errorMessage = await response.text();
          setErrorMessage(errorMessage);
        }
      } catch (error) {
        setErrorFetchPointsOfService(true);
        console.warn(error);
      }
    } else {
      console.error("Recaptcha Error");
    }
    setIsLoading(false);
  };

  useEffect(() => {
    if (isModalOpen) {
      //eslint-disable-next-line
      fetchCountries();
    }
  }, [fetchCountries, isModalOpen]);

  useEffect(() => {
    if (currentFormCountryId === "BR") {
      //eslint-disable-next-line
      fetchRegions();
    }
  }, [fetchRegions, currentFormCountryId]);

  useEffect(() => {
    if (currentFormRegionId) {
      //eslint-disable-next-line
      fetchCities();
    }
  }, [fetchCities, currentFormRegionId]);

  useEffect(() => {
    if (currentFormCityId) {
      //eslint-disable-next-line
      fetchDistricts();
    }
  }, [fetchDistricts, currentFormCityId]);

  useEffect(() => {
    if (
      currentFormCountryId &&
      currentFormRegionId &&
      currentFormCityId &&
      currentFormDistrictId
    ) {
      //eslint-disable-next-line
      fetchPointsOfService();
    } else if (currentFormCountryId && currentFormCountryId !== "BR") {
      fetchPointsOfService();
    }
  }, [
    fetchPointsOfService,
    currentFormCountryId,
    currentFormRegionId,
    currentFormCityId,
    currentFormDistrictId,
  ]);

  useEffect(() => {
    if (errorFetchPointsOfService) {
      showErrorToast("An error occurred while processing your request");
    }
  }, [errorFetchPointsOfService]);

  const formNotValid =
    isLoading ||
    currentPointsOfService.length < 1 ||
    !formUserSurname ||
    !emailRegex.test(formUserEmail);

  return (
    <>
      <Button
        variant="contained"
        size="small"
        onClick={handleOpenModal}
        disabled={disabled}
      >
        {t("CustomApp:btn.askForQuote", "Ask for Quote")}
      </Button>
      <BaseModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        title={t("CustomApp:btn.askForQuote", "Ask for Quote")}
        customSx={{
          minWidth: "30em",
          width: "25%",
        }}
        isLoading={isLoading}
      >
        <Box>
          <Grid container columnSpacing={1} rowSpacing={2}>
            <Grid size={12}>
              <LabeledInput
                required
                fullWidth={true}
                label={t("CustomApp:label.form.email", "E-Mail")}
                value={formUserEmail}
                handleChange={(val) => setFormUserEmail(val)}
              />
            </Grid>
            <Grid size={12}>
              <LabeledInput
                fullWidth={true}
                label={t("CustomApp:label.form.phone", "Phone")}
                value={formUserPhoneNr}
                handleChange={(val) => setFormUserPhoneNr(val)}
              />
            </Grid>
            <Grid size={6}>
              <LabeledInput
                fullWidth={true}
                label={t("CustomApp:label.form.name", "Name")}
                value={formUserName}
                handleChange={(val) => setFormUserName(val)}
              />
            </Grid>
            <Grid size={6}>
              <LabeledInput
                required
                fullWidth={true}
                label={t("CustomApp:label.form.surname", "Surname")}
                value={formUserSurname}
                handleChange={(val) => setFormUserSurname(val)}
              />
            </Grid>
            <Grid size={12}>
              <LabeledInput
                fullWidth={true}
                label={t("CustomApp:label.form.companyName", "Company Name")}
                value={formCompanyName}
                handleChange={(val) => setFormCompanyName(val)}
              />
            </Grid>
            <Grid size={10}>
              <LabeledInput
                fullWidth={true}
                label={t("CustomApp:label.form.street", "Street")}
                value={formUserStreet}
                handleChange={(val) => setFormUserStreet(val)}
              />
            </Grid>
            <Grid size={2}>
              <LabeledInput
                fullWidth={true}
                label={t("CustomApp:label.form.streetNr", "No.")}
                value={formUserStreetNr}
                handleChange={(val) => setFormUserStreetNr(val)}
              />
            </Grid>
            <Grid size={4}>
              <LabeledInput
                fullWidth={true}
                label={t("CustomApp:label.form.zipCode", "ZIP-Code")}
                value={formUserZipCode}
                handleChange={(val) => setFormUserZipCode(val)}
              />
            </Grid>
            <Grid size={8}>
              <LabeledInput
                fullWidth={true}
                label={t("CustomApp:label.form.city", "Town/City")}
                value={formUserCity}
                handleChange={(val) => setFormUserCity(val)}
              />
            </Grid>

            <Grid size={12}>
              <LabeledInput
                fullWidth={true}
                multiline={true}
                rows={3}
                label={t("CustomApp:label.form.formUserComment", "Comment")}
                maxLength={1000}
                value={formUserComment}
                handleChange={(val) => setFormUserComment(val)}
              />
            </Grid>
            <Grid size={12}>
              <QuoteFormSelect
                required
                currentVal={currentFormCountryId}
                fetchData={fetchCountries}
                hasError={errorFetchCountries}
                label={t(
                  "CustomApp:label.form.formPurchasePlace",
                  "Purchase Place",
                )}
                selectOptions={formCountries}
                setter={setCurrentFormCountryId}
              />
            </Grid>
            {currentFormCountryId === "BR" ? (
              <>
                <Grid size={12}>
                  <QuoteFormSelect
                    required
                    currentVal={currentFormRegionId}
                    fetchData={fetchRegions}
                    hasError={errorFetchRegions}
                    label={t("CustomApp:label.form.formRegion", "Region")}
                    selectOptions={formRegions}
                    setter={setCurrentFormRegionId}
                  />
                </Grid>
                <Grid size={12}>
                  <QuoteFormSelect
                    required
                    currentVal={currentFormCityId}
                    fetchData={fetchCities}
                    hasError={errorFetchCities}
                    label={t("CustomApp:label.form.formCity", "City")}
                    selectOptions={formCities}
                    setter={setCurrentFormCityId}
                    disabled={!currentFormRegionId}
                  />
                </Grid>
                <Grid size={12}>
                  <QuoteFormSelect
                    required
                    currentVal={currentFormDistrictId}
                    fetchData={fetchDistricts}
                    hasError={errorFetchDistricts}
                    label={t("CustomApp:label.form.formDistrict", "District")}
                    selectOptions={formDistricts}
                    setter={setCurrentFormDistrictId}
                    disabled={!currentFormCityId}
                  />
                </Grid>
              </>
            ) : (
              <></>
            )}
          </Grid>

          <Box display="flex" justifyContent="space-between" gap={2}></Box>
          {errorFetchPointsOfService ? (
            <Box display="flex" justifyContent="center">
              <IconButton aria-label="reload" onClick={fetchPointsOfService}>
                <RefreshIcon fontSize="inherit" />
              </IconButton>
            </Box>
          ) : (
            <></>
          )}
          {pointsOfService && pointsOfService.length > 0 ? (
            <Box sx={{ maxHeight: "15em", overflow: "auto" }}>
              <FormGroup>
                {pointsOfService.map((pos) => {
                  const {
                    displayName,
                    address: { country, email },
                  } = pos;

                  return (
                    <FormControlLabel
                      key={"pos-" + pos.address.id}
                      control={
                        <Checkbox
                          checked={currentPointsOfService.includes(
                            pos.address.id,
                          )}
                          onChange={() => {
                            handleChangeCurrentPOS(pos.address.id);
                          }}
                        />
                      }
                      label={
                        (displayName ? displayName : country.isocode) +
                        " - " +
                        email
                      }
                    />
                  );
                })}
              </FormGroup>
            </Box>
          ) : !isLoading &&
            !errorFetchPointsOfService &&
            currentFormCountryId &&
            (currentFormCountryId !== "BR" || currentFormDistrictId) ? (
            <Typography>
              {t("CustomApp:error.noPOSfound", "No Points of Service found.")}
            </Typography>
          ) : (
            <></>
          )}
        </Box>
        <Box display="flex" justifyContent="flex-end" pt={4}>
          <Button
            variant="contained"
            disabled={formNotValid}
            endIcon={<MailIcon />}
            onClick={handleOpenConfirmModal}
          >
            {t("CustomApp:btn.sendRequest", "Send Request")}
          </Button>
        </Box>
      </BaseModal>
      <ModalDialogConfirm
        isOpen={isConfirmModalOpen}
        onClose={handleCloseConfirmModal}
        endIcon={<MailIcon />}
        confirmLabel={t("CustomApp:btn.sendRequest", "Send Request")}
        onConfirm={handleSend}
        onCancel={handleCloseConfirmModal}
        message={t(
          "CustomApp:message.confirmSendQuoteRequest",
          "Sending this request will finalize the quote and prevent further changes.",
        )}
        title={t("CustomApp:title.confirmSendQuoteRequest", "Request quote")}
        isLoading={isLoading}
        hasError={sendingHasError}
        msgError={errorMessage}
      />
      <BaseModal
        isOpen={isSuccessModalOpen}
        onClose={handleCloseSuccessModal}
        title={t(
          "CustomApp:title.successSendQuoteRequest",
          "Thank you for your request!",
        )}
      >
        <Typography>
          {t(
            "CustomApp:message.successSendQuoteRequest",
            "We have forwarded your request to our sales department and you will receive a confirmation email shortly.",
          )}
        </Typography>
      </BaseModal>
    </>
  );
};
